import {isEventWithSpecialKeyPressed} from '../../../utils/keys'

export const shouldNavigate = (event: Event & React.KeyboardEvent) =>
  !event.defaultPrevented && !isEventWithSpecialKeyPressed(event)
